// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
}

body {
  margin: 0;
  padding: 0;
}

main {
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  /* Let wide content (tables) scroll inside the page instead of stretching it past the window. */
  min-width: 0;
}

/* Phones: the navigation sits on top instead of on the side */
@media (max-width: 599px) {
  .App {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,+FAA+F;EAC/F,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".App {\n  display: flex;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nmain {\n  padding: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  /* Let wide content (tables) scroll inside the page instead of stretching it past the window. */\n  min-width: 0;\n}\n\n/* Phones: the navigation sits on top instead of on the side */\n@media (max-width: 599px) {\n  .App {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
